// eslint-disable-next-line no-unused-vars
import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react'
import { capitalizeFLetter, fetchApiData } from '../../../fnc.js'

const refConst = require("../../../constants.js").v

export default function ModalTicket(props){

	const initialState = {
		selectedUserToAssigne: [],
		modalSearchTerm: "",
		lineInfoPerAccountId: {},
		version: "0.1.0"
	}

	const refModalAssignedTo = useRef(null);
	const [selectedUserToAssigne, setSelectedUserToAssigne] = useState(initialState.selectedUserToAssigne);
	const [lineInfoPerAccountId, setLineInfoPerAccountId] = useState(initialState.lineInfoPerAccountId);
	const [modalSearchTerm, setModalSearchTerm] = useState(initialState.modalSearchTerm);
	const [version, setVersion] = useState(initialState.version);

	useEffect(() => {
		if(refModalAssignedTo.current)
			modalAssignedTo(refModalAssignedTo.current)
	}, [props.pmaAccList, refModalAssignedTo?.current, selectedUserToAssigne, modalSearchTerm, lineInfoPerAccountId])

	let findEmailFromId = (id) => {
		let acc = props.pmaAccList? props.pmaAccList.find((v) => v.id === id) : [];
		console.info("sadadsada", props.pmaAccList);
		if(acc){
			return acc.data_firebase?.email.split("@")[0];
		}
		return "-"
	}

	let init = () => {
		resetPage()
		fetchApiData("eio", "getPMAAssignedAccount", {
			filters: JSON.stringify({
				'id_pma': props.pma.id
			})
		}, null, (r) => {
			console.log("PMA_assigned_to_accounts", r)
			setSelectedUserToAssigne(r.data.map(v => parseInt(v.id_account)))
			setLineInfoPerAccountId(r.data.reduce((acc, v) => {
				acc[v.id_account] = {
					line_from: v.line_from !== null? parseInt(v.line_from) : null,
					line_to: v.line_to !== null? parseInt(v.line_to) : null
				};
				return acc;
			}, {}))
		})
		modalAssignedTo(props.pma)
	}

	let submitAssignedData = () => {
		let users = selectedUserToAssigne.map(id => {
			return {
				'id_account': id,
				'id_pma': props.pma.id,
				'line_from': lineInfoPerAccountId[id]?.line_from || null,
				'line_to': lineInfoPerAccountId[id]?.line_to || null
			}
		})
		fetchApiData("eio", "setPMAAssignedAccount", {
			"id_pma": props.pma.id,
			'data': JSON.stringify(users)
		}, null, (r) => {
			console.log("PMA_assigned_to_accounts", r)
			props.getPmaList()
		})
	}

	let modalAssignedTo = (pma) => {
		// Reset modal search when opening modal
		console.log("selectedUserToAssigne2", selectedUserToAssigne)

		props.modal({
			show: true,
			title: "Assignment Users",
			html: () => {
				return <div>
					{
						selectedUserToAssigne.length > 0?
							<div className="alert alert-info">
								Selected users {selectedUserToAssigne.length} users:
								<ul>
									{selectedUserToAssigne.map(id => {
										return <li key={id}>{findEmailFromId(id)}</li>
									})}
								</ul>
							</div> : ""
					}
					<div className="mb-3">
						<input
							type="text"
							className="form-control"
							placeholder="Search users..."
							value={modalSearchTerm}
							onChange={(e) => setModalSearchTerm(e.target.value)}
						/>
					</div>
					<div className="list-group" style={{maxHeight: "300px", overflowY: "auto"}} >
						{
							props.pmaAccList? props.pmaAccList.filter(acc => {
								const email = acc.data_firebase?.email || '';
								const username = email.split('@')[0];
								return username.toLowerCase().includes(modalSearchTerm.toLowerCase());
							})
							.map((acc) => {
								let valLineFrom = lineInfoPerAccountId[acc.id]?.line_from !== null? parseInt(lineInfoPerAccountId[acc.id]?.line_from) : ''
								let valLineTo = lineInfoPerAccountId[acc.id]?.line_to !== null? parseInt(lineInfoPerAccountId[acc.id]?.line_to) : ''
								return (
									<button 
										key={acc.id}
										type="button" 
										className={"list-group-item list-group-item-action d-flex justify-content-between align-items-center" + (selectedUserToAssigne.indexOf(acc.id) !==  -1? " active" : "")}
										onClick={() => {
											
											setSelectedUserToAssigne(prevSelected => {
												const idx = prevSelected.indexOf(acc.id);
												if (idx === -1) {
													return [...prevSelected, acc.id];
												} else {
													return prevSelected.filter(id => id !== acc.id);
												}
											});
										}}
									>
										{acc.data_firebase?.email.split("@")[0]}
										<div className="float-end">
											<input 
												type="number" 
												className="form-control form-control-sm d-inline-block" 
												style={{width: "100px"}}
												value={valLineFrom}
												onChange={(e) => {
													const value = e.target.value;
													acc.line_from = value;
													setLineInfoPerAccountId(prev => ({...prev, [acc.id]: {line_from: value, line_to: acc.line_to}}));
												}}
												onClick={(e) => e.stopPropagation()}
												placeholder="line from"
											/>
											<input 
												type="number" 
												className="form-control form-control-sm d-inline-block ml-2" 
												style={{width: "100px"}}
												value={valLineTo}
												onChange={(e) => {
													const value = e.target.value;
													acc.line_to = value;
													setLineInfoPerAccountId(prev => ({...prev, [acc.id]: {line_from: lineInfoPerAccountId[acc.id]?.line_from, line_to: value}}));
												}}
												onClick={(e) => e.stopPropagation()}
												placeholder="line to"
											/>
										</div>
									</button>
								)
							}) : ""
						}
					</div>
				</div>
			}
			,ok: {
				title: "Save",
				fnc: (popup, close) => {
					submitAssignedData()
					close()
				}
			},
			exit: (popup, close) => {
				refModalAssignedTo.current = false
				close()
			},
			return: {
				title: "Close",
				fnc: (popup, close) => {
					refModalAssignedTo.current = false
					close()
				}
			}
		})
	}

	let resetPage = () => {
		for (const key in initialState) {
			if (initialState.hasOwnProperty(key)) {
				// const element = initialState[key];
				let val = JSON.parse(JSON.stringify(initialState[key]))
				console.info('Eval result', eval("set" + capitalizeFLetter(key))(val));
			}
		}
	}

	return (
		<div className={"pointer" + ("className" in props? props.className : ' list-group-item list-group-item-action p-2 text-center')} onClick={() => {
			refModalAssignedTo.current = props.pma
			init()
		}}>
			{
				props.title
			}
		</div>
	);
}